module.exports = __webpack_public_path__ + "img/male-dentist-showing-teeth-radio.4a2a787c.png";